<template>
  <div class="all">
    <Tar></Tar>
    <div class="box">
      <router-view />
    </div>
    <div class="Notice" v-show="flag">
      <div class="notice_title"></div>
      <p style="font-size: 1rem;margin-left: 5%;margin-top: 3%;">{{ content }}</p>
      <p style="font-size: 1rem;margin-left: 5%;margin-top: 6%;">{{ time }}</p>
      <div style="width: 100%;margin-top: 5%;  display: flex;  justify-content: center;"><el-button type="primary"
          size="small" round @click="cancel()">知道了</el-button></div>
    </div>
  </div>
</template>
<script>
import Tar from "@/components/tar.vue";
import axios from "axios";
import { reactive, toRefs } from "vue";
import { ElMessage, ElMessageBox } from 'element-plus'

export default {
  name: "Home",
  components: {
    Tar,
  },
  setup() {
    const data = reactive({
      title: "",
      content: "",
      time: '',
      flag: false,

    });
    const notice = () => {

      let notice_falg = localStorage.getItem('notice_falg');
      if (notice_falg == 'true') {
        axios.get("http://47.105.39.99:4578/manage_center/api/announcement/query").then((res) => {
          if (res.data.data != null) {
            data.flag = true
            data.content = res.data.data.content
            data.title = res.data.data.title
            data.time = res.data.data.releaseTime
            localStorage.setItem("notice_falg", 'false')
          }
        })
      }
    }
    const cancel = () => {
      localStorage.setItem("notice_falg", 'false')
      data.flag = false
    }
    notice()
    return { ...toRefs(data), cancel };
  }

};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

html,
body {
  width: 100%;
  height: 100%;
}

#app {
  width: 100%;
  height: 100%;
}

li {
  list-style: none;
}

.all {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/img/back.png");
  background-size: 100% 100%;
  position: relative;
}

.box {
  width: 100%;
  height: 90%;
  position: absolute;
  z-index: 100;
  color: azure;
  top: 10%;
}

.Notice {
  position: absolute;
  width: 25%;
  height: 40%;
  background-color: rgb(255, 255, 255);
  top: 28%;
  left: 38%;
  z-index: 1000;
  border-radius: 4%;
  overflow: hidden;
}

.notice_title {
  background: url('../../assets/img/notice_back.png');
  width: 100%;
  height: 30%;
  background-size: 100% 100%;
}
</style>